(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/receiver/non-corporate.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/receiver/non-corporate.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const grassrootsQueryApi = svs.grassroots.store.grassrootsQueryApi;
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useContext = _React.useContext;
const Button = svs.ui.Button;
const isCorporateSite = svs.grassroots.shared.data.isCorporateSite;
const NonCorporate = _ref => {
  let receiver = _ref.receiver;
  const id = receiver.id,
    longname = receiver.longname;
  const _useContext = useContext(svs.grassroots.context.Context),
    _useContext$selectedR = _useContext.selectedReceivers,
    selectedReceivers = _useContext$selectedR.selectedReceivers,
    setSelectedReceivers = _useContext$selectedR.setSelectedReceivers;
  const _grassrootsQueryApi$u = grassrootsQueryApi.useSetReceiverSelectionMutation(),
    _grassrootsQueryApi$u2 = _slicedToArray(_grassrootsQueryApi$u, 2),
    setReceiverSelection = _grassrootsQueryApi$u2[0],
    setReceiverResult = _grassrootsQueryApi$u2[1];
  const _grassrootsQueryApi$u3 = grassrootsQueryApi.useRemoveReceiverSelectionMutation(),
    _grassrootsQueryApi$u4 = _slicedToArray(_grassrootsQueryApi$u3, 2),
    removeReceiverSelection = _grassrootsQueryApi$u4[0],
    removeReceiverResult = _grassrootsQueryApi$u4[1];
  const _grassrootsQueryApi$u5 = grassrootsQueryApi.useReplaceReceiverSelectionMutation(),
    _grassrootsQueryApi$u6 = _slicedToArray(_grassrootsQueryApi$u5, 2),
    replaceReceiverSelection = _grassrootsQueryApi$u6[0],
    replaceReceiverResult = _grassrootsQueryApi$u6[1];
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    supportBtn = _useState2[0],
    setSupportBtn = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    cancelBtn = _useState4[0],
    setCancelBtn = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    replaceBtn = _useState6[0],
    setReplaceBtn = _useState6[1];
  const sendAnalytics = (action, receiverName) => {
    const evt = {
      category: 'Gräsroten',
      action,
      opt_label: receiverName
    };
    svs.components.analytics.trackEvent(evt);
  };
  const openErrorDialog = () => {
    const dialog = new svs.ui.dialog.Confirm({
      branding: svs.grassroots.tenant,
      type: 'error',
      title: 'Ett fel har uppstått',
      message: [{
        text: 'Var vänlig försök igen senare'
      }],
      actions: [{
        title: 'Okej'
      }]
    });
    svs.ui.dialog.api.add(dialog);
  };
  useEffect(() => {
    if (selectedReceivers !== null && selectedReceivers !== void 0 && selectedReceivers.some(receiver => receiver.id === id)) {
      setCancelBtn(true);
      setSupportBtn(false);
      setReplaceBtn(false);
    } else if (!isCorporateSite && (selectedReceivers === null || selectedReceivers === void 0 ? void 0 : selectedReceivers.length) < 3) {
      setCancelBtn(false);
      setSupportBtn(true);
      setReplaceBtn(false);
    } else if (!isCorporateSite && (selectedReceivers === null || selectedReceivers === void 0 ? void 0 : selectedReceivers.length) === 3) {
      setCancelBtn(false);
      setSupportBtn(false);
      setReplaceBtn(true);
    }
  }, [selectedReceivers]);
  const onCancelSubmit = () => {
    removeReceiverSelection(id);
    sendAnalytics('Avsluta mitt stöd', longname);
  };
  const onSupportSubmit = () => {
    if (!svs.grassroots.shared.data.isCorporateSite && svs.core.userSession && svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      setReceiverSelection(id);

      sendAnalytics('Ge mitt stöd', longname);
    } else {
      svs.components.customer_login.login();
    }
  };
  const onReplaceSubmit = (addId, removeId) => {
    replaceReceiverSelection({
      receiverToAdd: addId,
      receiverToRemove: removeId
    });

    sendAnalytics('Ge mitt stöd', longname);
  };

  useEffect(() => {
    if (removeReceiverResult.isSuccess) {
      var _removeReceiverResult;
      setCancelBtn(false);
      setSupportBtn(true);
      setSelectedReceivers(removeReceiverResult === null || removeReceiverResult === void 0 || (_removeReceiverResult = removeReceiverResult.data) === null || _removeReceiverResult === void 0 ? void 0 : _removeReceiverResult.receivers);
    } else if (removeReceiverResult.isError) {
      openErrorDialog();
    }
  }, [removeReceiverResult.isLoading]);

  useEffect(() => {
    if (setReceiverResult.isSuccess) {
      var _setReceiverResult$da;
      setCancelBtn(true);
      setSupportBtn(false);
      setSelectedReceivers(setReceiverResult === null || setReceiverResult === void 0 || (_setReceiverResult$da = setReceiverResult.data) === null || _setReceiverResult$da === void 0 ? void 0 : _setReceiverResult$da.receivers);
    } else if (setReceiverResult.isError) {
      openErrorDialog();
    }
  }, [setReceiverResult.isLoading]);

  useEffect(() => {
    if (replaceReceiverResult.isSuccess) {
      var _replaceReceiverResul;
      setCancelBtn(true);
      setSupportBtn(false);
      setReplaceBtn(false);
      setSelectedReceivers(replaceReceiverResult === null || replaceReceiverResult === void 0 || (_replaceReceiverResul = replaceReceiverResult.data) === null || _replaceReceiverResul === void 0 ? void 0 : _replaceReceiverResul.receivers);
    } else if (replaceReceiverResult.isError) {
      openErrorDialog();
    }
  }, [replaceReceiverResult.isLoading]);
  return React.createElement("div", {
    className: "margin-top-2"
  }, cancelBtn && React.createElement(Button, {
    block: true,
    className: "grassroots-remove-button",
    disabled: removeReceiverResult === null || removeReceiverResult === void 0 ? void 0 : removeReceiverResult.isLoading,
    inverted: true,
    onClick: onCancelSubmit
  }, "Avsluta mitt st\xF6d"), replaceBtn && React.createElement("div", null, React.createElement("p", null, "Du har valt max antal f\xF6reningar (3st). F\xF6r att v\xE4lja", ' ', longname, ' ', "m\xE5ste du ers\xE4tta n\xE5gon f\xF6rening nedan."), selectedReceivers === null || selectedReceivers === void 0 ? void 0 : selectedReceivers.map(receiver => React.createElement(Button, {
    block: true,
    className: "margin-top-1 grassroots-replace-button",
    disabled: replaceReceiverResult === null || replaceReceiverResult === void 0 ? void 0 : replaceReceiverResult.isLoading,
    inverted: true,
    key: receiver.id,
    onClick: () => onReplaceSubmit(id, receiver.id)
  }, "Ers\xE4tt", ' ', receiver === null || receiver === void 0 ? void 0 : receiver.longname))), supportBtn && React.createElement(Button, {
    block: true,
    className: "grassroots-add-button",
    disabled: setReceiverResult === null || setReceiverResult === void 0 ? void 0 : setReceiverResult.isLoading,
    inverted: true,
    onClick: onSupportSubmit
  }, "Ge mitt st\xF6d"));
};
svs.grassroots.components.receiver.non_corporate = NonCorporate;

 })(window);